import ChevronDownIcon from '@svg/chevron-down.svg';
import PropTypes from 'prop-types';

import FormRow from './FormRow';
import styles from './SelectInput.module.scss';

function SelectInput({
  placeholder,
  required,
  onChange,
  options,
  label,
  value,
  name,
  id,
  ...attributes
}) {
  return (
    <FormRow id={id} label={label} required={required}>
      <div className={styles.wrapper}>
        <select
          className={styles.select}
          required={required}
          onChange={onChange}
          value={value}
          name={name}
          id={id}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...attributes}
        >
          <option value="" disabled>
            Selecteer een optie
          </option>
          {options.map(option => (
            <option value={option.value} key={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <ChevronDownIcon className={styles.icon} />
      </div>
    </FormRow>
  );
}

SelectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default SelectInput;
